angular.module('zc.core')
  .factory('columnChartV2Config', columnChartV2Config);

columnChartV2Config.$inject = ['$window', 'baseChartV2Config'];
function columnChartV2Config($window, baseChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'column' },
      colors: ['#26c9ff', '#666666']
    },
    xAxis: {
      title: { text: null },
      type: 'category'
    },
    yAxis: {
      title: { text: null },
      min: 0,
      labels: {
        formatter: function() {
          let suffix, valueDecimals;
          suffix = this.chart.series[0].tooltipOptions.valueSuffix || '';
          valueDecimals = this.chart.series[0].tooltipOptions.valueDecimals || 0;
          return $window.Highcharts.numberFormat(this.value, valueDecimals) + suffix;
        }
      }
    }
  }, baseChartV2Config);
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/column_chart_v2_config.service.js